var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCategoryObjects = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.654 8.75a.833.833 0 1 1-.2 1.642l-1.05.964v2.81H9.57v-2.81l-1.048-.964a.54.54 0 0 1-.078.015l-.124.01a.832.832 0 1 1 0-1.667.833.833 0 0 1 .813 1.023l.855.79.855-.79-.013-.067-.01-.122c0-.46.374-.834.834-.834Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.988 0c3.905 0 7.082 2.992 7.082 6.666a6.234 6.234 0 0 1-2.057 4.86 5.8 5.8 0 0 0-1.968 3.683l-.129 1.086v2.44h-.001a1.13 1.13 0 0 1-.97 1.095 13.1 13.1 0 0 1-1.957.17 13.243 13.243 0 0 1-1.959-.17 1.133 1.133 0 0 1-.97-1.093v-2.44l-.128-1.088a5.807 5.807 0 0 0-1.968-3.684 6.226 6.226 0 0 1-2.059-4.859C2.904 2.991 6.082 0 9.988 0Zm1.677 16.249H8.308v.835h1.68v.832h-1.68v.693c.562.086 1.127.133 1.664.141a12.067 12.067 0 0 0 1.694-.141l-.001-2.36ZM9.988 1.25c-3.231 0-5.834 2.448-5.834 5.416C4.1 8.187 4.702 9.61 5.78 10.58a7.065 7.065 0 0 1 2.386 4.419h3.646l.044-.29a7.038 7.038 0 0 1 2.322-4.112 4.977 4.977 0 0 0 1.645-3.884c0-3.015-2.603-5.463-5.834-5.463Z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCategoryObjects);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/category-objects.c51d60014dbcad026c03c821e0298f78.svg";